import { IPlacedOutboundListReport } from './list-report';

export enum AnalyticsSignalREvent {
  ListOpenedReportEvent = 'ListOpenedReportEvent',
  ListPlacedReportEvent = 'ListPlacedReportEvent',
  ListAddedReportEvent = 'ListAddedReportEvent',
  ListOpenedSessionReportEvent = 'ListOpenedSessionReportEvent',
}

export interface IAnalyticsSignalrBaseEvent<T = unknown> {
  eventName: AnalyticsSignalREvent;
  payload: T;
}

export interface IListPlacedReportSignalrEvent
  extends IAnalyticsSignalrBaseEvent<IPlacedOutboundListReport> {}

export interface ILiveViewersPayload {
  productListId: string;
  users: { internalId?: string; externalId: string }[];
}

export interface IListOpenedSessionReportEvent
  extends IAnalyticsSignalrBaseEvent<ILiveViewersPayload> {}
